import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, catchError, forkJoin } from 'rxjs';
import { Report, ReverseDimensionMap, YearObject } from '../interfaces';
import { DimensionService, LanguageService, PivotGridConfigService, ReportService } from '../services';
import { PivotGridConfig } from '../utils/pivot-grid-config';

export interface PivotGridOptions {
  config: PivotGridConfig | boolean | null;
  dimensions: ReverseDimensionMap;
  report: Report;
  distinctYears: YearObject[];
}

@Injectable({
  providedIn: 'root',
})
export class PivotGridConfigResolver implements Resolve<PivotGridOptions> {
  constructor(
    private router: Router,
    private dimensionService: DimensionService,
    private languageService: LanguageService,
    private pivotGridConfigService: PivotGridConfigService,
    private reportService: ReportService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PivotGridOptions> {
    const reportId = route.paramMap.get('reportId') as string;

    const folked = forkJoin({
      config: this.pivotGridConfigService.getPivotGridConfig(reportId).pipe(catchError(() => this.router.navigate(['report-not-found']))),
      dimensions: this.dimensionService.getDimensions(this.languageService.language, reportId),
      parentDimensionrecords: this.dimensionService.getParentDimensionLabels(this.languageService.language, reportId),
      report: this.reportService.getReportData(reportId, this.languageService.language),
      reportId: this.pivotGridConfigService.getReportId(reportId),
      distinctYears: this.pivotGridConfigService.getDistinctYears(reportId),
    });

    return folked;
  }
}

// childlessDimensionLabels: this.dimensionService.getChildlessDimensionLabels(this.languageService.language, reportId),
